"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emergencyContactDeserializeOldType = exports.emergencyContactDeserialize = exports.emergencyContactOldDescription = void 0;
const ModelDescription_1 = require("../type-descriptions/ModelDescription");
const String_1 = require("../type-descriptions/String");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializePhoneNumber_1 = __importDefault(require("./deserializePhoneNumber"));
const deserializeString_1 = require("./deserializeString");
exports.emergencyContactOldDescription = (0, ModelDescription_1.modelDescription)({
    properties: {
        email: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }),
        name: (0, String_1.stringDescription)(),
        phone: (0, String_1.stringDescription)(),
    },
});
function emergencyContactDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        email: (0, unwrap_1.default)(object.email, deserializeString_1.deserializeString),
        name: (0, deserializeString_1.deserializeString)(object.name),
        phone: (0, deserializePhoneNumber_1.default)(object.phone),
        uid: (0, deserializeString_1.deserializeString)(object.uid),
    };
}
exports.emergencyContactDeserialize = emergencyContactDeserialize;
function emergencyContactDeserializeOldType(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: String(id),
        email: (0, unwrap_1.default)(object.email, deserializeString_1.deserializeString),
        name: (0, deserializeString_1.deserializeString)(object.name),
        phone: (0, deserializePhoneNumber_1.default)(object.phone),
    };
}
exports.emergencyContactDeserializeOldType = emergencyContactDeserializeOldType;
